import customConfig from "../config";

const APP_ENV = {
  DEVELOPMENT: "development",
  STAGING: "staging",
  PRODUCTION: "production",
};

const getAppHostname = () =>
  typeof window !== "undefined" ? window.location.hostname || "" : "";

const isLocalHost = (hostname = "") =>
  !hostname || hostname === "localhost" || hostname === "127.0.0.1";

/**
 * Resolves deployment environment from the admin app host.
 * @returns {'development'|'staging'|'production'|null}
 */
const getAppEnvironment = (hostname = getAppHostname()) => {
  if (isLocalHost(hostname) || hostname.includes("mrs-dev")) {
    return APP_ENV.DEVELOPMENT;
  }
  if (hostname.includes("mrs-stg")) {
    return APP_ENV.STAGING;
  }
  if (hostname.includes("miraie.in") || hostname.includes("webapp.miraie")) {
    return APP_ENV.PRODUCTION;
  }
  return null;
};

/**
 * Resolves Feedback Statistics HTML URL for the current environment.
 * Optional override: REACT_APP_FEEDBACK_STATISTICS_URL
 */
const getFeedbackStatisticsUrl = () => {
  const fromEnv = (process.env.REACT_APP_FEEDBACK_STATISTICS_URL || "").trim();
  if (fromEnv) {
    return fromEnv;
  }

  const env = getAppEnvironment();
  return customConfig.feedbackStatisticsUrls?.[env] || "";
};

export default getFeedbackStatisticsUrl;
